var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBgEllipseBlur(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 2056 616",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Bg Ellipse",
    filter: "url(#filter0_f_0_14)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1028 488C1525.06 488 1928 326.823 1928 128H128C128 326.823 530.944 488 1028 488Z",
    fill: "url(#paint0_linear_0_14)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1028 488C1525.06 488 1928 326.823 1928 128H128C128 326.823 530.944 488 1028 488Z",
    fill: "var(--fill-1, #FFFEFC)",
    fillOpacity: 0.75
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_0_14",
    x: 0,
    y: 0,
    width: 2056,
    height: 616,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 64,
    result: "effect1_foregroundBlur_0_14"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_0_14",
    x1: 1311.11,
    y1: 128,
    x2: 796.08,
    y2: 514.197,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F3ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#97D5FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#F69DB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD601"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgEllipseBlur);
export default __webpack_public_path__ + "static/media/bg-ellipse-blur.71adcf4c8da4074b1ffd37c410caef0a.svg";
export { ForwardRef as ReactComponent };